import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuditMgmtComponent} from 'src/app/main/audit-mgmt/audit-mgmt.component';

const routes: Routes = [
  {
    path: '',
    component: AuditMgmtComponent,
    title: 'audit'
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuditMgmtRoutingModule {
}
